import { Config } from '../contexts/ConfigContext';
import { JapaneseConfig } from '../types/config';

const STORAGE_KEYS = {
  APP_CONFIG: 'jp_toolkit_config',
  JAPANESE_CONFIG: 'jp_toolkit_japanese_config'
} as const;

/**
 * 保存应用配置到本地存储
 */
export function saveAppConfig(config: Config): void {
  try {
    localStorage.setItem(STORAGE_KEYS.APP_CONFIG, JSON.stringify(config));
  } catch (error) {
    console.error('Failed to save app config:', error);
  }
}

/**
 * 从本地存储加载应用配置
 */
export function loadAppConfig(): Config | null {
  try {
    const stored = localStorage.getItem(STORAGE_KEYS.APP_CONFIG);
    return stored ? JSON.parse(stored) : null;
  } catch (error) {
    console.error('Failed to load app config:', error);
    return null;
  }
}

/**
 * 保存日语相关配置到本地存储
 */
export function saveJapaneseConfig(config: JapaneseConfig): void {
  try {
    localStorage.setItem(STORAGE_KEYS.JAPANESE_CONFIG, JSON.stringify(config));
  } catch (error) {
    console.error('Failed to save Japanese config:', error);
  }
}

/**
 * 从本地存储加载日语相关配置
 */
export function loadJapaneseConfig(): JapaneseConfig | null {
  try {
    const stored = localStorage.getItem(STORAGE_KEYS.JAPANESE_CONFIG);
    return stored ? JSON.parse(stored) : null;
  } catch (error) {
    console.error('Failed to load Japanese config:', error);
    return null;
  }
}

/**
 * 清除所有配置
 */
export function clearAllConfig(): void {
  try {
    localStorage.removeItem(STORAGE_KEYS.APP_CONFIG);
    localStorage.removeItem(STORAGE_KEYS.JAPANESE_CONFIG);
  } catch (error) {
    console.error('Failed to clear config:', error);
  }
}